<template>
  <div style="width: 100%;height: 100%;" class="m-0 p-0">
    <div>
      <router-link
        :to="{
          path: '/DischargePermissions/DischargeCheckOut/' + dataFromParent.id,
          query: {
            storeId: dataFromParent.storeId,
            isProcess: dataFromParent.isProcess
          }
        }"
      >
        <vs-button
          icon-pack="feather"
          class="hide-in-print float-right"
          type="filled"
          style="background-color:#444"
        >
          {{ $t("Back") }}
        </vs-button>
      </router-link>
    </div>
    <div
      id="labelWarrantCard"
      class="card pt-0 mb-2 mt-0"
      v-for="(lebel, index) in allDataForShow"
      :key="index"
      :class="useButtonForPrint ? '' : 'hide-in-print'"
    >
      <div class="vx-row" style="height: 0.7cm">
        <div class="vx-col w-1/3"></div>
        <div class="vx-col w-1/2 mx-0">
          <h3
            class="float-left mr-12"
            style="font-size: 1rem;font-weight: 900;"
          >
            {{ dataFromParent.basketId ? dataFromParent.basketId : "--" }}
          </h3>
          <h3 class="float-right" style="font-size: 1rem;font-weight: 900;">
            {{ allDataForShow[index].rowId }}
          </h3>
        </div>
        <div class="vx-row w-1/6 vx-col">
          <QRCanvas :options="options" />
        </div>
      </div>
      <div class="vx-row" dir="ltr" style="height: 0.7cm;font-weight: 900;">
        <h3 class="pt-2 pl-6 pr-12">{{ allDataForShow[index].avasysName }}</h3>
      </div>
      <div
        class="vx-row"
        style="height: 0.5cm;padding-right: 30%;font-weight: 900;"
      >
        <barcode
          :value="lebel.serial"
          :options="{ displayValue: false }"
        ></barcode>
      </div>
      <h4
        class="my-0"
        style="text-align: center;margin-right: 30%;letter-spacing: 1px;line-height: 1.3;"
      >
        {{ lebel.serial ? lebel.serial : "null" }}
      </h4>
      <div dir="ltr" class="px-12 m-0" style="width: 100%">
        <h3 class="mb-1">
          {{ allDataForShow[index].mainWarranty.startTimeOfMainWarranty }}
        </h3>
        <h3 class="m-0">
          {{ allDataForShow[index].mainWarranty.endTimeOfMainWarranty }}
        </h3>
      </div>
      <div class="vx-row float-right px-12 m-0" style="height: 15%;">
        <h3
          v-for="(alternativeWarrantiesInfo, index) in allDataForShow[index]
            .alternativeWarrantiesInfo"
          :key="index"
        >
          {{ alternativeWarrantiesInfo.alternativeType }}:{{
            alternativeWarrantiesInfo.guarantyDuration
          }}
        </h3>
      </div>
    </div>
    <div class="vx-row">
      <div class="w-full vx-col">
        <vs-button
          type="button"
          class="float-right purple hide-in-print"
          @click="printWindow()"
          >{{ $t("Print") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import VueBarcode from "@xkeshi/vue-barcode";
import { QRCanvas } from "qrcanvas-vue";
import "@/assets/scss/vuesax-rtl/_labelWarrantCard.scss";

export default {
  name: "warehouseManagement_DischargePermission_Index",
  data() {
    return {
      modelForPrintApi: {
        inventoryTransactionId: this.$route.query.transactionId,
        stockId: this.$route.query.stockId
      },
      modelForApiCompeletePrint: {
        dischargePermissionId: this.$route.query.transactionId,
        itemCode: this.$route.query.itemCode
      },
      oldSerialsBeforeTwoButton: {},
      useButtonForPrint: false,
      notAddNewSerials: false,
      allDataForShow: {},
      model: {},
      modelForApi: {},
      dataFromLocalStorage: [],
      dataFromParent: this.$route.query,
      listSerialsUnseen: [],
      currentTime: "",
      options: {
        cellSize: 8,
        data: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      recipientInfoDetails: "draftOrder/recipientInfoDetails"
    })
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      printCompeleteOneRowDischarge: "checkOutTransactions/printCompeleteOneRowDischarge",
      ReadInfoForWarrantyCard: "checkOutTransactions/ReadInfoForWarrantyCard"
    }),
    countNewSerials() {
      this.dataFromLocalStorage = JSON.parse(
        localStorage.getItem("basket" + this.dataFromParent.basketId + "store" + this.dataFromParent.storeId)
      );
      for (let index = 0; index < this.dataFromLocalStorage.length; index++) {
        if (
          this.dataFromParent.itemCode ==
          this.dataFromLocalStorage[index].itemCode
        ) {
          for (
            let ii = 0;
            ii < this.dataFromLocalStorage[index].serialsInfo.length;
            ii++
          ) {
            if (
              !this.dataFromLocalStorage[index].serialsInfo[ii]
                .isshowWarrantyCard
            ) {
              var serialData = {
                serial: this.dataFromLocalStorage[index].serialsInfo[ii].serial,
                index: this.dataFromLocalStorage[index].serialsInfo[ii].index
              };
              this.listSerialsUnseen.push(serialData);
            }
          }
          break;
        }
      }
    },
    async load() {
      this.notAddNewSerials = false;
      this.modelForApi = {};
      await this.countNewSerials();
      if (this.listSerialsUnseen.length) {
        await this.$swal({
          title:
            "تعداد " +
            this.listSerialsUnseen.length +
            " سریال جدید چاپ شود یا تمام سریال ها ؟",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "فقط سریال های جدید",
          cancelButtonText: "تمام سریال ها"
        }).then(result => {
          if (result.value) {
            this.onlyShowNewSerilas();
          } else {
            this.withoutNewSerilas();
          }
        });
      } else {
        this.withoutNewSerilas();
      }
      this.updateValueisshowWarrantyCard();
    },
    updateValueisshowWarrantyCard() {
      for (let index = 0; index < this.dataFromLocalStorage.length; index++) {
        if (
          this.dataFromParent.itemCode ==
          this.dataFromLocalStorage[index].itemCode
        ) {
          for (
            let ii = 0;
            ii < this.dataFromLocalStorage[index].serialsInfo.length;
            ii++
          ) {
            this.dataFromLocalStorage[index].serialsInfo[
              ii
            ].isshowWarrantyCard = true;
          }
          break;
        }
      }
      localStorage.removeItem("basket" + this.dataFromParent.basketId);
      localStorage.setItem(
        "basket" + this.dataFromParent.basketId,
        JSON.stringify(this.dataFromLocalStorage)
      );
    },
    withoutNewSerilas() {
      this.modelForApi = {
        stockId: this.dataFromParent.productId,
        sortSerialsDto: this.dataFromParent.sortSerialsDto
      };
      this.ReadInfoForWarrantyCard(this.modelForApi).then(r => {
        this.allDataForShow = r;
        this.options.data = r[0].qrCodeInfo;
      });
    },
    onlyShowNewSerilas() {
      this.modelForApi = {
        stockId: this.dataFromParent.productId,
        sortSerialsDto: this.listSerialsUnseen
      };
      this.ReadInfoForWarrantyCard(this.modelForApi).then(r => {
        this.allDataForShow = r;
        this.options.data = r[0].qrCodeInfo;
      });
    },
    printWindow() {
      console.log(this.modelForApiCompeletePrint)
      this.useButtonForPrint = true;
      setTimeout(() => {
        console.log('print')
        window.print();
        this.printCompeleteOneRowDischarge(this.modelForApiCompeletePrint).then(() => {
          
          this.$router.push({
            path:
              "/DischargePermissions/DischargeCheckOut/" +
              this.dataFromParent.id,
            query: {
              storeId: this.dataFromParent.storeId,
              isProcess: this.dataFromParent.isProcess
            }
          });
        });
      }, 1000);
    }
  },
  components: {
    QRCanvas,
    VueBarcode
  }
};
</script>
